import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class TrackingB2bService extends BaseService {
  public getB2bTransaction(
    start: string,
    end: string,
    status: string,
    limit: number,
    offset: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `transaction-ezb2b/order-file?StartDate=${start}&EndDate=${end}&Status=${status}&Limit=${limit}&Offset=${offset}`
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
